var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_9826)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3640_9826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.263184,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3640_9826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7148 5C12.4884 5 13.2303 5.35603 13.7772 5.98978C14.3242 6.62352 14.6315 7.48306 14.6315 8.37931C14.6315 9.27556 14.3242 10.1351 13.7772 10.7688C13.2303 11.4026 12.4884 11.7586 11.7148 11.7586C10.9413 11.7586 10.1994 11.4026 9.65245 10.7688C9.10547 10.1351 8.79818 9.27556 8.79818 8.37931C8.79818 7.48306 9.10547 6.62352 9.65245 5.98978C10.1994 5.35603 10.9413 5 11.7148 5ZM5.88151 7.41379C6.34818 7.41379 6.78151 7.55862 7.15651 7.81931C7.03151 9.2 7.38151 10.571 8.09818 11.6428C7.68151 12.5697 6.84818 13.2069 5.88151 13.2069C5.21847 13.2069 4.58258 12.9017 4.11374 12.3585C3.6449 11.8153 3.38151 11.0786 3.38151 10.3103C3.38151 9.54213 3.6449 8.80538 4.11374 8.26217C4.58258 7.71896 5.21847 7.41379 5.88151 7.41379ZM17.5482 7.41379C18.2112 7.41379 18.8471 7.71896 19.3159 8.26217C19.7848 8.80538 20.0482 9.54213 20.0482 10.3103C20.0482 11.0786 19.7848 11.8153 19.3159 12.3585C18.8471 12.9017 18.2112 13.2069 17.5482 13.2069C16.5815 13.2069 15.7482 12.5697 15.3315 11.6428C16.0581 10.556 16.3953 9.18667 16.2732 7.81931C16.6482 7.55862 17.0815 7.41379 17.5482 7.41379ZM6.29818 17.3103C6.29818 15.3117 8.72318 13.6897 11.7148 13.6897C14.7065 13.6897 17.1315 15.3117 17.1315 17.3103V19H6.29818V17.3103ZM1.71484 19V17.5517C1.71484 16.2097 3.28984 15.08 5.42318 14.7517C4.93151 15.4083 4.63151 16.3159 4.63151 17.3103V19H1.71484ZM21.7148 19H18.7982V17.3103C18.7982 16.3159 18.4982 15.4083 18.0065 14.7517C20.1398 15.08 21.7148 16.2097 21.7148 17.5517V19Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_9826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.263184)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.276dfa06afadd545ac59b4c04c463757.svg";
export { ForwardRef as ReactComponent };